import { HomeHero, ShowCase } from 'smooth-doc/components';
import { Grid, Row, Col } from '@smooth-ui/core-sc';
import Helmet from 'react-helmet';
import React from 'react';
export default {
  HomeHero,
  ShowCase,
  Grid,
  Row,
  Col,
  Helmet,
  React
};